import { createContext } from 'react';
import { User, Session } from '@supabase/supabase-js';
import { Database } from '@/integrations/supabase/types';
import { UserData } from '@/lib/profile/models/user.model';

export type UserRole = Database['public']['Enums']['user_role'];

export interface AuthContextType {
  user: User | null;
  userData: UserData | null;
  session: Session | null;
  userRole: UserRole | null;
  isApproved: boolean;
  signUp: (email: string, password: string, metadata: Record<string, unknown>) => Promise<{ error: Error | null }>;
  signIn: (email: string, password: string) => Promise<{ error: Error | null }>;
  signOut: () => Promise<void>;
  loading: boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
